/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Tab_RecordInputs */



/**
* | output |
* | --- |
* | "Play record" |
*
* @param {Profile_Tab_RecordInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_tab_record = /** @type {((inputs?: Profile_Tab_RecordInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Tab_RecordInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Historique de jeu")
	if (locale === "es") return /** @type {LocalizedString} */ ("Historial de juego")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Histórico de partidas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Storico di gioco")
	return /** @type {LocalizedString} */ ("Play record")
});